<template>
  <div
    class="fb fb-col ff-regular bg-F6F6F6 fb-main-start font-34 height"
    v-if="deptStatistics"
  >
    <div class="hidden relative bg-FFFFFF mb-20">
      <div class="fb fb-between-center">
        <div class="fb fb-between-center fb-main-center item-flex-1">
          <div class="lh-48 p-0-16 item-shrink-0" @click="handlerToSelectDate">
            <span class="font-28">{{ dateStr }}</span
            ><i class="iconfont c-171A1D font-24">&#xe681;</i>
          </div>
          <div
            v-if="switchList && switchList.length"
            class="pr-16 hidden-x item-flex-1 w-adapt-100 fb fb-main-end fb-cross-center"
          >
            <span
              class="font-28 inline-block text-ellipsis w-adapt-24"
              @click="handlerToSelectDept"
              >{{ switchList[selectedDeptIndex].name }}</span
            >
            <i class="iconfont c-171A1D font-24" v-if="switchList.length > 1"
              >&#xe681;</i
            >
          </div>
        </div>
        <!-- 报表 -->
        <div
          class="c-171A1D font-28 text-right fb fb-cross-center fb-main-end pr-16"
          v-if="showToReports"
        >
          <span @click="handlerJumpReportsPage">
            <i class="iconfont mr-4 font-34">&#xe6a9;</i>报表
          </span>
        </div>
      </div>
      <div class="pb-20 p-0-16 c-fff">
        <div
          class="call-summary fb fb-main-between fb-cross-center font-24"
          :class="
            showLevel === 2 || activeTabType === 'myClass'
              ? 'call-summary--gray'
              : ''
          "
        >
          <div class="item-flex-1 height-full">
            <div class="height-full fb fb-col fb-main-between">
              <div>{{ computedIsHistory ? `本周得分` : '今日得分' }}</div>
              <div class="font-24 today-score"
                ><span
                  class="font-72 ff-ding-condensed-bold"
                  v-if="computedIsHistory"
                  >{{
                    deptStatistics.overviewData.totalScore | countScore
                  }}</span
                >
                <span class="font-72 ff-ding-condensed-bold" v-else>{{
                  deptStatistics.overviewData.todayScore | countScore
                }}</span>
                <span>分</span></div
              >
            </div>
          </div>
          <div class="item-flex-1 height-full" v-if="!computedIsHistory">
            <div class="fb fb-cross-end fb-main-end height-full"
              >本周得分
              <span
                class="font-40 inline-block ff-ding-condensed-bold ml-4 mr-2 total-score"
                >{{ deptStatistics.overviewData.totalScore | countScore }}</span
              >分</div
            ></div
          >
        </div>
      </div>
    </div>
    <!-- 卡片列表 -->
    <div
      v-if="deptStatistics.items && deptStatistics.items.length"
      class="p-0-16"
    >
      <div
        class="pt-12 bg-FFFFFF bd-radio-8 mb-16"
        v-for="(item, index) in deptStatistics.items"
        :key="index"
        @click="handlerItemClick(item, index)"
      >
        <div class="c-171A1D mb-6 fb fb-cross-center fb-main-between p-0-16">
          <div class="font-30 ff-medium">{{ item.deptName }}</div>
        </div>
        <div class="fb fb-cross-center h-60 w-full bd-radio-6 fb-main-around">
          <div class="c-171A1D text-center" v-if="!computedIsHistory">
            <div class="font-40 mb-2 text-bold-600">{{
              item.todayScore | countScore
            }}</div>
            <div class="font-24 c-171A1D-56">今日得分</div>
          </div>
          <div class="c-171A1D text-center">
            <div class="font-40 mb-2 text-bold-600">{{
              item.totalScore | countScore
            }}</div>
            <div class="font-24 c-171A1D-56">本周得分</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timeFormat } from '@/utils/comUtils'
export default {
  name: 'commonClassRankList',
  components: {},
  props: {
    dateStr: {
      type: String,
      default: ''
    },
    startDimDay: {
      type: Number,
      default: null
    },
    endDimDay: {
      type: Number,
      default: null
    },
    showLevel: {
      type: Number,
      defalut: 1
    },
    deptStatistics: {
      type: Object,
      defalut: null
    },
    switchList: {
      type: Array,
      defalut: null
    },
    selectedDeptIndex: {
      type: Number,
      defalut: 0
    },
    activeTabType: {
      type: String,
      defalut: ''
    },
    showToReports: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedIsHistory() {
      return timeFormat(new Date(), 'YYYYMMDD') > this.endDimDay
    }
  },
  filters: {
    /* eslint-disable */
    countScore: function (_score) {
      if (_score === 0) {
        return 0
      }
      if (!_score) {
        return '-'
      }
      return `${_score > 0 ? '+' : ''}${_score}`
    }
  },
  data() {
    return {
      loading: null,
      deptPicker: null
    }
  },
  methods: {
    handlerItemClick(item, index) {
      this.$emit('handlerItemClick', item, index)
    },
    handlerToSelectDate() {
      this.$emit('handlerToSelectDate')
    },
    handlerToSelectDept() {
      if (this.switchList.length === 1) {
        return
      }
      let _target = this.switchList
      let columns = _target.reduce((_list, item) => {
        return _list.concat(item.name)
      }, [])
      let that = this
      this.deptPicker = this.$Picker({
        $props: {
          columns,
          defaultActive: this.selectedDeptIndex
        },
        $events: {
          confirm(index) {
            that.$emit('handlerSelectGrade', _target[index[0]], index[0])
          }
        }
      }).show()
    },
    handlerJumpReportsPage() {
      this.$emit('handlerJumpReportsPage')
    }
  }
}
</script>

<style lang="scss" scoped>
.call-summary {
  height: 96px;
  background: linear-gradient(76deg, #3323aa 0%, #5c4bdd 98%, #5c4bdd 98%);
  border-radius: 8px;
  padding: 16px;
  &.call-summary--gray {
    background: linear-gradient(106deg, #97aacb 0%, #4b6281 100%);
  }
}
.today-score {
  margin-bottom: -10px;
}
.total-score {
  margin-bottom: -4px;
}
</style>
